/**
 * Reaction emoji — kept in sync with the backend allowlist
 * (backend/src/Support/Emoji.php). QUICK is the inline "top 5" row; ALL is the
 * set the "+" picker exposes (and what the server will accept).
 */

export const QUICK_EMOJI = ['❤️', '😍', '😂', '👏', '🎉'] as const;

export const ALL_EMOJI = [
  // Quick row
  '❤️', '😍', '😂', '👏', '🎉',
  // Smileys
  '😀', '😁', '😊', '🥰', '😘', '😎', '🤩', '😇', '🙂', '😉',
  '😢', '😭', '😮', '😯', '😴', '🤔', '😳', '🥳', '😬', '🤗',
  // Gestures
  '👍', '👎', '🙌', '🙏', '👌', '🤝', '💪', '✌️', '🤞', '👋',
  // Hearts & symbols
  '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '💖', '💕', '💗',
  '⭐', '🌟', '✨', '🔥', '💯', '🥹', '😺', '🌈', '🎈', '🍼',
  '👶', '🧸', '🎂', '🌸', '☀️',
] as const;
